import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }



export const noOfDropedMissionAction = createAsyncThunk(
    'no-of-droped-mission',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/admins/api/no-of-drop-mission?&s_date=${data?.s_date}&e_date=${data?.e_date}`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const noOfDropedMissionSlice = createSlice({
    name: 'no-of-droped-mission',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(noOfDropedMissionAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(noOfDropedMissionAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(noOfDropedMissionAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const noOfDropedMissionReducer = noOfDropedMissionSlice.reducer